import { OnInit } from '@angular/core';
var UnloggedComponent = /** @class */ (function () {
    function UnloggedComponent() {
    }
    UnloggedComponent.prototype.ngOnInit = function () { };
    return UnloggedComponent;
}());
export { UnloggedComponent };
